import { ModelBase } from '../../core/model/model-base';
import { DirectDebitStatus } from './const/enums';

export class PayerDirectDebit {
  constructor() {}

  company: string;
  directDebitStatus: DirectDebitStatus;
  payerNumber: string;
  bankgiro: string;
}

export class Payer extends ModelBase {
  constructor() {
    super();
    this.contactIdentification = '';
    this.emailInvoicing = '';
    this.directDebit = [];
  }

  bankAccount: string;
  contactIdentification: string;
  directDebit: PayerDirectDebit[];
  get displayName(): string {
    return this.name;
  }
  name: string;
  emailInvoicing: string;
  number: string;

  toAutocompleteValue(consumerType?: 'list' | 'field', culture?: string): string {
    if (consumerType) {
      switch (consumerType) {
        case 'field':
          return this.toString();
        case 'list':
          return `${this.number} ${this.name} ${this.contactIdentification}`;
      }
    }
  }

  toJSON() {
    return this.id;
  }

  toString() {
    return `${this.number} ${this.name}`;
  }
}
